<template>
    <div class="taker-list">
        <gcmcn-filters
            ref="gcmcn-filters"
            :filter-values="[selectedSortType, searchFilter, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <dropdown
                name="Region"
                :multiple="true"
                :list="awsregions"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedRegions.length > 0 ? selectedRegions : []"
                @on-select-item="setSelectedRegions"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div
            v-if="filteredTakers.length > 0"
            class="takers-container"
            :style="{height: `calc(100vh - ( ${usedHeight}px)`}"
            v-scroll-to="$route.params.takerUid">
            <takerCard
                v-for="taker in filteredTakers"
                :key="taker.uid"
                :taker="taker"
                :selectedTakerUid="selectedTakerUid"
                @changeSelectedTaker="changeSelectedTaker"
            ></takerCard>
        </div>
        <div v-else class="list-empty">No takers</div>
    </div>
</template>

<script>

import takerCard from './takerCard.vue';
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter
} from 'gcmcn-common';
import { mapGetters } from 'vuex';

export default {

    components: {
        takerCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter
    },
    props: {
        selectedTakerUid: {
            type: String,
            required: true,
        },
    },
    data: function(){
        return {
            selectedSortType: 'asc',
            searchFilter: '',
            usedHeight: 0,
            selectedRegions: [],
        };
    },

    computed: {
        ...mapGetters([
            'takers',
            'windowWidth',
            'selectedEntitiesForFilter',
            'awsregions',
        ]),
        filteredTakers (){
            let takers = this.takers.slice();
            if(this.selectedSortType){
                takers.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    takers.reverse();
                }
            }

            if(this.selectedEntitiesForFilter.length > 0){
                takers = takers.filter((taker) => this.selectedEntitiesForFilter.includes(taker.scopes.entity_uid));
            }
            if(this.selectedRegions.length > 0){
                takers = takers.filter((taker) => this.selectedRegions.includes(taker.aws_region_uid));
            }
            if(this.searchFilter){
                takers = takers.filter((ev) => ev.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return takers;
        }

    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    mounted (){
        this.computeFilterHeight();
    },
    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        changeSelectedTaker(uid) {
            this.$emit('changeSelectedTaker', uid);
        },
        resetFilters (){
            this.selectedSortType = '';
            this.selectedRegions = [];
            this.$store.commit('CLEAR_ALL_FILTERS');
            this.$refs.search.clear();
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        setSelectedRegions(regions){
            this.selectedRegions = regions;
        }
    },
};
</script>

<style lang="scss">
.taker-list {
    .column-title {
        color: #AAA;
    }
    .takers-container {
        overflow-y: scroll;
        padding-right: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/takerList.vue